/*eslint-disable*/
import{ request} from '@/utils/request/request'
export function videoMonitor(query) {
  return request({
    url: 'api/equipment/v1/Videos',
    method: 'get',
    params:query
  })
}
export function getToken(){
  return request({
    url:'api/equipment/v1/JK_GetToken',
    method:'get'
  })
}
export function state(){
  return request({
    url:'api/lapp/device/ptz/start',
    method:'post'
  })
}